var React = require('react');

function Ch5ImageJaggedLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FC1930","strokeWidth":"2","d":"M36.3 1L2 35.3l34.3 34.3L2 103.9l34.3 34.3L2 172.5l34.3 34.3L2 241.1l34.3 34.3L2 309.7 36.3 344 2 378.3l34.3 34.3L2 446.9l34.3 34.3L2 515.5l34.3 34.3L2 584.1l34.3 34.3L2 652.7 36.3 687"}));
}

Ch5ImageJaggedLine.defaultProps = {"width":"38","height":"688","viewBox":"0 0 38 688"};

module.exports = Ch5ImageJaggedLine;

Ch5ImageJaggedLine.default = Ch5ImageJaggedLine;
